import axios from "axios";

const ListLessonAPI = async (token, bimbelType) => {
  try {
    const BASED_URL = process.env.REACT_APP_BASED_URL;
    const params = `/admin/lesson/list?token=${token}&bimbelType=${bimbelType}`;
    const url = `${BASED_URL}${params}`;
    const res = await axios.get(url);
    return res.data;
  } catch (err) {
    return err.response;
  }
};

export default ListLessonAPI;
